export function parseEntities(rawEntities: any) {
  if (!rawEntities) return [];

  const entityTuples = rawEntities.split(";").map((tuple: any) => tuple.trim());

  const entities = entityTuples
    .map((tuple: any) => {
      const match = tuple.match(/\(([^,]+),\s*([^\)]+)\)/); // Extract "name" and "type"
      if (match) {
        return {
          name: match[1].trim(), // Entity name
          type: match[2].trim(), // Entity type
        };
      }
      return null;
    })
    .filter((entity: any) => entity !== null);

  return entities;
}
